module.exports = __webpack_public_path__ + "static/media/ico_dropdown.93c70c27.svg";